import styled from 'styled-components';

import { BaseContainer } from '../Containers';

export const BarContainer = styled(BaseContainer)`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;
